import JobsShowcaseSrc from 'assets/jobs-page/Jobs.png'
import { pagesPathsEnum } from 'common/router/router.enum'
import { generateBasicSeoTags } from 'common/utils/seo'
import Head from 'next/head'
import Image from 'next/image'
import { getCommunityServerSideProps } from 'services/community/community.server'
import { getCommunityLayout } from 'services/community/community.layout'
import { CommunityJobsSection } from 'services/jobs/components/CommunityJobs/CommunityJobsSection'
import IndividualsNavbar from 'services/landing-page-individuals/components/individualsNavbar'
import styled from 'styled-components'

const Jobs = ({ isCandidate = false }: { isCandidate?: boolean }) => {
  return (
    <div>
      <Head>{generateBasicSeoTags({ url: pagesPathsEnum.communityJobs })}</Head>

      <Div>
        {!isCandidate && (
          <div className="p-3">
            <IndividualsNavbar text="I'm an employer" />
          </div>
        )}

        <div className="w-full mx-auto px-2">
          <Image src={JobsShowcaseSrc} loading="eager" alt="Jobs showcase" className="w-full border-round-2xl" />
        </div>

        <CommunityJobsSection />
      </Div>
    </div>
  )
}

export const getServerSideProps = getCommunityServerSideProps

Jobs.getLayout = getCommunityLayout

const Div = styled.div`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
`

export default Jobs
